//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  name: "MissionMetrics",
  props: {
    mission: {
      type: Object,
    },
    availableReviews: {
      type: Number,
      value: 0,
    },
    doneReviews: {
      type: Number,
      value: 0,
    },
    currentGoal: {
      type: String,
    },
  },
  data: () => ({
    goalWidth: 0,
  }),
  methods: {
    currentGoalWidth(targetGoal, currentGoal) {
      return {
        width: currentGoal * this.goalWidth / targetGoal + 'px'
      }
    },
    prettyNumber(number) {
      if(number < 1000) {
        return number;
      }
      else if(number > 999 && number < 1000000) {
        return parseFloat(number / 1000).toFixed(1) + 'K';
      }      
      else if(number > 1000000) {
        return parseFloat(number / 1000000).toFixed(1) + 'M';
      }
    },
  },
  mounted : function() {
    this.goalWidth =  this.$refs["goalLine"].clientWidth;
  }
}
